<div #alert class="alert alert-info alert-dismissible fade show m-0" role="alert">
    <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
        <span aria-hidden="true">&times;</span>
    </button>
    <strong>No existen registros!</strong> para los filtros seleccionados.
</div>